import { useState } from "react";
import UserManagement from "./UserManagement";
import PermissionsMatrix from "./PermissionsMatrix";
import SecurityDevices from "./SecurityDevices";

const SUBTABS = ["User Management", "Permissions", "Security"];

export default function UsersAccess() {
  const [sub, setSub] = useState(SUBTABS[0]);
  return (
    <div>
      <div className="flex gap-1.5 mb-6">
        {SUBTABS.map((s) => (
          <button key={s} data-testid={`subtab-${s.toLowerCase().replace(/\s/g, "-")}`} onClick={() => setSub(s)}
            className={`px-4 h-9 rounded-full text-sm font-bold ${sub === s ? "bg-[#181B34] text-white" : "bg-white border border-[#181B34]/10 text-[#4b4e63]"}`}>{s}</button>
        ))}
      </div>
      {sub === "User Management" && <UserManagement />}
      {sub === "Permissions" && <PermissionsMatrix />}
      {sub === "Security" && <SecurityDevices />}
    </div>
  );
}
